<template>
  <v-layout column>
    <v-flex xs12>
      <v-card class="elevation-3 py-2">
        <v-card-title>
          <h4>Пункты доставки пользователей</h4>
        </v-card-title>
        <v-expansion-panels popout multiple>
          <v-expansion-panel
            v-for="(item, i) in this.activeChildUsers"
            :key="i"
          >
            <v-expansion-panel-header>
              <v-layout>
                <v-flex xs2 md1>
                  <v-icon color="primary">{{ icons.tooltipAccount }}</v-icon>
                </v-flex>
                <v-flex xs8>{{ item.email }} ({{ item.name }})</v-flex>
              </v-layout>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <Points
                :points="points"
                :selectedPoints="getChildUserPoints(item.userId)"
                v-on:add-points="addPoints($event, item.userId)"
                v-on:remove-point="removePoint($event, item.userId)"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { Icon } from "@/helpers";

const Points = () => import("@/components/_common/Points");

export default {
  components: {
    Points,
  },
  computed: {
    ...mapState({
      user: (state) => state.users.user,
      childUsers: (state) => state.users.childUsers,
      points: (state) => state.points.points,
      childUsersPoints: (state) => state.points.childUsersPoints,
    }),
    activeChildUsers: function () {
      return this.childUsers.filter((user) => !user.deleted);
    },
  },
  methods: {
    ...mapActions({
      getChildUsers: "users/GET_CHILD_USERS",
      getPoints: "points/GET_POINTS",
      getChildUsersPoints: "points/GET_CHILD_USERS_POINTS",
      createChildUserPoint: "points/CREATE_CHILD_USER_POINT",
      removeChildUserPoint: "points/REMOVE_CHILD_USER_POINT",
    }),
    getChildUserPoints: function (userId) {
      return this.childUsersPoints != null &&
        this.childUsersPoints.length > 0 &&
        this.childUsersPoints.filter((item) => item.userId === userId).length >
          0
        ? this.childUsersPoints.filter((item) => item.userId === userId)[0]
            .points
        : null;
    },
    addPoints: function (points, userId) {
      this.createChildUserPoint({ userId, points });
    },
    removePoint: function (point, userId) {
      this.removeChildUserPoint({ userId, pointId: point.pointId });
    },
  },
  data: () => ({
    icons: {
      tooltipAccount: Icon.tooltipAccount,
    },
  }),
  mounted: async function () {
    await this.getChildUsers();
    await this.getPoints(this.user.userId);
    await this.getChildUsersPoints(this.user.userId);
  },
};
</script>
